import { render, staticRenderFns } from "./LsaAccountAlerts.vue?vue&type=template&id=21b18fba&scoped=true"
import script from "./LsaAccountAlerts.vue?vue&type=script&lang=js"
export * from "./LsaAccountAlerts.vue?vue&type=script&lang=js"
import style0 from "./LsaAccountAlerts.vue?vue&type=style&index=0&id=21b18fba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b18fba",
  null
  
)

export default component.exports